import { BiCodeAlt } from 'react-icons/bi'
import { FaRulerCombined, FaWordpressSimple } from 'react-icons/fa'
import { FiPenTool } from 'react-icons/fi'
export const whatIdo = [
  {
    id:1,
    title:'Web Development',
    icon: <BiCodeAlt/>,
    desc: 'Design/Develop a complete website for you using HTML, CSS, JavaScript, React JS, Bootstrap, and make the website responsive with all screens.',
    color: 'pink'
  },
  {
    id:2,
    title:'Wordpress Development',
    icon: <FaWordpressSimple />,
    desc: 'High-quality development of sites at the professional level.',
    color: 'blue'
  },
  {
    id:3,
    title: 'Ui/Ux Design',
    icon: <FaRulerCombined/>,
    desc: 'The most modern and high-quality design made at a professional level.',
    color: 'green'
  },
  {
    id:4,
    title:'Graphic Design',
    icon: <FiPenTool />,
    desc: 'Converting ideas to creatives designs that\'s serves my clients goals.',
    color: 'secondary'
  },
]

// =============>>- resume data -<<==============
export const resume = {
  edu:[
    {
      id:1,
      date:'2008 : 2012',
      title: 'Faculty of Social Work',
      subTitle: 'ASYUT UNIVERSITY',
      desc: 'The faculty of Social Work is working on graduating a social worker equipped with knowledge and skills according to local criteria of social work',
      link:'https://www.aun.edu.eg/'
    },
    {
      id:2,
      date:'Aug 2021 : Des 2021',
      title:'ITI web development track',
      subTitle:'ITI',
      desc: 'Youth Enablement for Freelancing Initiative',
      link:'https://www.iti.gov.eg'
    }

  ],
  exp:[
    {
      id: 5,
      date: 'Oct 2021 : present',
      company: 'Startup Defenders',
      postition: 'Frontend Developer',
      link: 'https://startupdefenders.com',
      desc: 'startups solve some of the problems commonly associated with running a startup by providing'
    },
    {
      id:4,
      date: '2021 : present',
      company: 'Freelancer',
      postition:'Wordpress developer',
      link:'',
      desc:''
    },
    {
      id:3,
      date: '2017 : 2021',
      company: 'Ramz Adverting | KSA',
      postition: 'Graphic Designer',
      link:'https://r4adv.com',
      desc: 'Ramz Adverting Agancy for printing services, Laser works, Trophies, presents, gifts, Outdoor and indoor advertsing'
    },
    {
      id: 2,
      date: '2016',
      company: 'Nowarah Graphic | Egypt',
      postition: 'Graphic Designer',
      link: null,
      desc: 'Provides many services: Designing, Printing, packaging and Branding'
    },
    {
      id: 1,
      date: '2015 : 2016',
      company: 'Eldrini print | Egypt',
      postition: 'Graphic Designer',
      link: 'https://eldrini.com',
      desc: 'Products and services: Designing, All kind of printing (offset, outdoor, indoor.. etc), Event coordination, Branding and positioning'
    },
  ],
  skills:[
      {title:'HTML', img:'/skills/html.png'},
      {title:'CSS', img:'/skills/css.png'},
      {title:'Javascript', img:'/skills/js.png'},
      {title:'React js', img:'/skills/react.png'},
      {title:'Sass', img:'/skills/sass.png'},
      {title:'Bootstrap', img:'/skills/bootstrap.png'},
      {title:'Git', img:'/skills/git.png'},
      {title:'Github', img:'/skills/github.png'},
      {title:'Api', img:'/skills/api.png'},
      {title:'Wordpress', img:'/skills/wp.png'},
      {title:'Figma', img:'/skills/figma.png'},
      {title:'Adobe xd', img:'/skills/xd.png'},
      {title:'Adobe photoshop', img:'/skills/ps.png'},
      {title:'Adobe Illustrator', img:'/skills/ai.png'},
      {title:'Adobe Indesign', img:'/skills/id.png'},
    ],

}
// =============>>- designs -<<==============
export const designs = [
  {
    src:'/designs/01.jpg',
    title:'design',
    tags:['packaging', 'photoshop']
  },
  // {
  //   src:'/designs/02.jpg',
  //   title:'design 2',
  //   tags:['social media', 'photoshop']
  // },
  // {
  //   src:'/designs/03.jpg',
  //   title:'design',
  //   tags:['social media', 'photoshop']
  // },
  // {
  //   src:'/designs/04.jpg',
  //   title:'design',
  //   tags:['social media', 'photoshop']
  // },
  // {
  //   src:'/designs/05.jpg',
  //   title:'design',
  //   tags:['social media', 'photoshop']
  // },
  // {
  //   src:'/designs/06.jpg',
  //   title:'design',
  //   tags:['social media', 'photoshop']
  // },
  {
    src:'/designs/07.jpg',
    title:'Ink toner packaging design for Amida Co.',
    tags:['flyer design', 'photoshop', 'illustrator']
  },
  {
    src:'/designs/08.jpg',
    title:'Flyer design for Lyaan mobile shop in KSA.',
    tags:['menu design', 'photoshop', 'illustrator']
  },
  {
    src:'/designs/09.jpg',
    title:'Menu design for Snap coffe shop in KSA.',
    tags: ['menu design', 'photoshop', 'illustrator']
  },
  {
    src:'/designs/10.jpg',
    title: 'Menu design for Snap coffe shop in KSA.',
    tags: ['menu design', 'photoshop', 'illustrator']
  },
  {
    src:'/designs/11.jpg',
    title: 'Menu design for Snap coffe shop in KSA.',
    tags: ['menu design', 'photoshop', 'illustrator']
  },
  {
    src:'/designs/12.jpg',
    title: 'Menu design for Snap coffe shop in KSA.',
    tags: ['menu design', 'photoshop', 'illustrator']  },
  {
    src:'/designs/13.jpg',
    title: 'Menu design for Snap coffe shop in KSA.',
    tags: ['menu design', 'photoshop', 'illustrator']  },
  {
    src:'/designs/14.jpg',
    title: 'Menu design for Snap coffe shop in KSA.',
    tags: ['menu design', 'photoshop', 'illustrator']  },
  {
    src:'/designs/15.jpg',
    title:'Women sports Flyer design for Suadi Arabian client ',
    tags:['Flyer design', 'photoshop', 'illustrator']
  },
  {
    src:'/designs/16.jpg',
    title:'Boutque Aleen logo design for Client in KSA.',
    tags: ['Logo design', 'branding', 'illustrator']
  },
  {
    src:'/designs/17.jpg',
    title:'Book cover design for Saudi Arabian Author.',
    tags:['Book cover design', 'photoshop']
  },
  {
    src:'/designs/18.jpg',
    title:'Ministory of education Flyer design in KSA.',
    tags: ['Flyer design', 'photoshop', 'illustrator']
  },
  {
    src:'/designs/19.jpg',
    title:'Deleivery Social media design',
    tags:['social media', 'photoshop']
  },
  {
    src:'/designs/20.jpg',
    title:'Book word typography design',
    tags:['Typography design', 'photoshop']
  },{
    src:'/designs/21.jpg',
    title:'Table social media design for Expandcart platform',
    tags:['social media', 'photoshop']
  },{
    src:'/designs/22.jpg',
    title: 'Mathaf word typography design',
    tags: ['Typography design', 'Illustrator']
  },{
    src:'/designs/23.jpg',
    title: 'Azeem word typography design',
    tags: ['Typography design', 'Illustrator']
  },{
    src:'/designs/24.jpg',
    title: 'Haq word typography design',
    tags: ['Typography design', 'Illustrator']
  },{
    src:'/designs/25.jpg',
    title:'Book cover design for Saudi Arabian Author.',
    tags:['Book cover', 'photoshop']
  },{
    src:'/designs/26.jpg',
    title: 'Unoffical Pril social media design',
    tags:['social media', 'photoshop']
  },
  {
    src: '/designs/27.jpg',
    title: 'Ramadan offers social media design in KSA.',
    tags: ['social media', 'photoshop']
  },
  {
    src: '/designs/28.jpg',
    title: 'Shiny wash logo branding design in KSA.',
    tags: ['Braning','Logo design', 'photoshop']
  },
  {
    src: '/designs/29.jpg',
    title: 'Design for safety and prevention instructions from the Corona virus while entering mosques in KSA.',
    tags: ['Printing design', 'Illustrator', 'photoshop']
  },
  {
    src: '/designs/30.jpg',
    title: 'Design for safety and prevention instructions from the Corona virus while entering mosques in KSA.',
    tags: ['Printing design','Illustrator', 'photoshop']
  },
  {
    src: '/designs/31.jpg',
    title: 'Design for safety and prevention instructions from the Corona virus while entering mosques in KSA.',
    tags: ['Printing design','Illustrator', 'photoshop']
  },
  {
    src: '/designs/32.jpg',
    title: 'Design for safety and prevention instructions from the Corona virus while entering mosques in KSA.',
    tags: ['Printing design','Illustrator', 'photoshop']
  },
  {
    src: '/designs/33.jpg',
    title: 'Bebekac milk social media design',
    tags: ['social media', 'photoshop']
  },
  {
    src: '/designs/34.gif',
    title: 'Company profile design for Saudi Arabian client',
    tags: ['Bruchore design','Booklet' ,'Illstrator','photoshop']
  },
]
// =============>>- web projects  -<<==============
export const webProjects = [
  {
    src: '/web/10.png',
    title: 'Web admin dashboard',
    tags: ['Reactjs', 'Redux', 'Redux toolkit'],
    url:'https://borderdb.vercel.app/',
    github:'https://github.com/desgbr/border-dashboard'
  },
  {
    src: '/web/01.png',
    title: 'Web admin dashboard',
    tags: ['Reactjs', 'Redux', 'Redux toolkit'],
    url:'https://adoodlz-clepxc0tn-egy-team-dev.vercel.app/',
    github:'#'
  },
  {
    src: '/web/02.png',
    title: 'Ecommerce website using Reactjs',
    tags: ['Reactjs', 'Redux', 'Redux toolkit'],
    url:'https://shop-gbr.vercel.app/',
    github:'https://github.com/desgbr/eshop'
  },
  {
    src: '/web/03.png',
    title: 'Saferoad landing page with multilangual option',
    tags: ['Reactjs', 'Redux', 'Redux toolkit', 'react-i18next'],
    url:'https://www.saferoad.com.sa/',
    github:'/#'
  },
  {
    src: '/web/04.png',
    title: 'Eqra book library website',
    tags: ['Html5', 'Css3', 'Javascript'],
    url:'https://ktppdf.vercel.app/',
    github:'https://github.com/desgbr/ktbpdf'
  },
  {
    src: '/web/05.png',
    title: 'Assuit blood union website',
    tags: ['Reactjs', 'react-bootstrap', 'react-router-dom', 'typewriter'],
    url:'https://abdu-gbr.vercel.app/',
    github:'/#'
  },
  {
    src: '/web/11.png',
    title: 'my works on codepen',
    tags: ['Html', 'Css', 'Javascipt', 'Ui designs to web pages'],
    url:'https://codepen.io/desgbr',
    github:'/#'
  },
  {
    src: '/web/06.png',
    title: 'Luxury hotels website',
    tags: ['Html5', 'Css3', 'Javascript'],
    url:'https://luxury-gbr.vercel.app/',
    github:'/#'
  },
  {
    src: '/web/07.png',
    title: 'Ecommerce website',
    tags: ['Html5', 'Css3', 'Javascript'],
    url:'https://desgbr.github.io/shop/',
    github:'https://github.com/desgbr/shop'
  },
  {
    src: '/web/08.png',
    title: 'Max couch Personal courses landing page',
    tags: ['Html5', 'Css3', 'Javascript'],
    url:'https://desgbr.github.io/maxcouch/',
    github:'https://github.com/desgbr/maxcouch'
  },
  {
    src: '/web/09.png',
    title: 'Old portfolio website',
    tags: ['Html5', 'Css3', 'Javascript'],
    url:'https://desgbr.github.io/cv/pages/exp.html#',
    github:'https://github.com/desgbr/cv-old'
  },
]
// =============>>-  -<<==============
// =============>>-  -<<==============
// =============>>-  -<<==============
// =============>>-  -<<==============
